import React, { useEffect, useState } from "react";
import {
  getCity,
  setCity,
  deleteCity,
  getCounties,
  getDictionaryCities,
} from "../../services/dictionary";
import Lists from "../../modules/hcmd/components/Lists";
import { useParams } from "react-router-dom";
import Forms from "../../modules/hcmd/components/Forms";
import { usePermission } from "../../services/auth";

Cities.propTypes = {};

function Cities(props) {
  let { id } = props;

  const [isForm, setIsForm] = useState(false);

  const permissions = usePermission("dictionary");
  const params = useParams();
  if (!id && !isNaN(parseInt(params.id)) && parseInt(params.id) >= 0) {
    id = parseInt(params.id);
    if (!isForm) {
      setIsForm(true);
    }
  } else if (!isNaN(parseInt(id)) && parseInt(id) >= 0 && !isForm) {
    setIsForm(true);
  } else if (isForm) {
    setIsForm(false);
  }

  // ide jonnek a tipusnal hasznalt egyeb adatok deklaralasa
  const [counties, setCounties] = useState([]);
  useEffect(() => {
    getCounties()
      .then((response) => {
        setCounties(response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  // ide jon az oszlopok deklaralasa
  const columns = [
    {
      field: "id",
      fieldType: "number",
      hide: true,
    },
    {
      field: "name",
      fieldType: "text",
      headerName: "Megnevezés",
      validation: {
        required: true,
        minLength: 3,
      },
    },
    {
      field: "zip",
      fieldType: "text",
      headerName: "Irányítószám",
      validation: {
        required: true,
        minLength: 4,
      },
    },
    {
      field: "countyId",
      fieldType: "select",
      headerName: "Megye",
      validation: {
        required: true,
      },
      valueGetter: (params) => {
        const county = counties.find((item) => item.id === params.row.countyId);
        return county ? county.name : `ismeretlen ${params.row.countyId}`;
      },
    },
    {
      field: "isActive",
      fieldType: "boolean",
      defaultValue: true,
      headerName: "Státusz",
      width: 100,
      valueGetter: (params) => {
        return params.row.isActive ? "aktív" : "inaktív";
      },
    },
  ];

  // ide jon a fejlec deklaralasa
  const header = {
    title: "Települések",
    url: "/dictionary/cities",
    item: "település",
  };

  return (
    <>
      {isForm && (
        <Forms
          editable={true}
          id={id}
          header={header}
          permissions={permissions}
          columns={columns}
          getFunc={getCity}
          setFunc={setCity}
          counties={counties}
        ></Forms>
      )}
      {!isForm && (
        <Lists
          header={header}
          permissions={permissions}
          getFunc={getDictionaryCities}
          isDictionary={true}
          deleteFunc={deleteCity}
          columns={columns}
          counties={counties}
        ></Lists>
      )}
    </>
  );
}

export default Cities;
